export default {
  // 登录
  'login': {
    'welcome': '欢迎使用',
    'platform': '智慧运维平台',
    'username': '请输入账户名称',
    'password': '请输入登录密码',
    '登录': '登录',
    'usernameRequired': '请输入登录名称',
    'usernameLength': '长度在1到10个字符',
    'passwordRequired': '请输入登录密码',
    'passwordLength': '长度在5到15个字符',
    '欢迎使用': '欢迎使用',
    '智慧运维平台': '智慧运维平台',
    '请输入账户名称': '请输入账户名称',
    '请输入登录密码': '请输入登录密码',
    '请输入登录名称': '请输入登录名称',
    '长度在1到10个字符': '长度在1到10个字符',
    '长度在5到15个字符': '长度在5到15个字符',
  },
  'header': {
    'username': '用户名',
    'announcement': '公告',
    'publishTime': '发布时间',
    'logout': '退出',
    '用户名': '用户名',
    '公告': '公告',
    '发布时间': '发布时间',
    '退出': '退出',
  },
  'project': {
    'title': '智慧水务管理平台' // 添加这一行，使用原来的中文标题
  },
  // menu: {
  //   项目首页: '项目首页',
  //   账务报表: '账务报表',
  //   交款退款: '交款退款',
  //   基础资料: '基础资料',
  //   抄收与设置: '抄收与设置',
  //   系统管理: '系统管理'
  // },
  // submenu: {
  //   充值记录: '充值记录',
  //   账单流水: '账单流水',
  //   售水日报: '售水日报',
  //   售水月报: '售水月报',
  //   售水年报: '售水年报',
  //   用水类型: '用水类型',
  //   位置信息: '位置信息',
  //   表具类型: '表具类型',
  //   水表档案: '水表档案',
  //   阀控策略: '阀控策略',
  //   账户管理: '账户管理',
  //   全局配置: '全局配置',
  //   预警推送: '预警推送'
  // },
  // 项目首页
  'users': {
    'projectName': '项目名称',
    'username': '用户名',
    'isAdmin': '是否是管理员',
    'deviceTotal': '设备总数量',
    'balanceCount': '余额数量',
    'totalBalance': '总剩余额',
    'owingCount': '当前欠费数量',
    'owingAmount': '总欠费额',
    'payment': '交款退款',
    'meterReading': '抄收与设置',
    'billFlow': '账单流水',
    '已结算用水量统计': '已结算用水量统计',
    '按月': '按月',
    '按日': '按日',
    '异常告警': '异常告警',
    '用户余额不足告警': '用户余额不足告警',
    'serialNumber': '序号',
    'meterNumber': '表号',
    'userName': '用户名称',
    'location': '位置',
    'valveStatus': '阀门状态',
    'abnormalReason': '异常原因',
    'view': '查看',
    '本月账务统计数据': '本月账务统计数据',
    'thisMonth': '本月',
    'wechatPayment': '微信缴费金额',
    'businessWater': '业务售水金额',
    'discountWater': '优惠售水金额',
    'systemTransfer': '系统结转金额',
    'platformRefund': '平台退费金额',
    'paymentId': '缴费编号',
    'meterID': '表号',
    'balance': '余额',
    'address': '地址',
    'yes': '是',
    'no': '否',
    '是': '是',
    '否': '否',
    '项目名称': '项目名称',
    '用户名': '用户名',
    '是否是管理员': '是否是管理员',
    '设备总数量': '设备总数量',
    '余额数量': '余额数量',
    '总剩余额': '总剩余额',
    '当前欠费数量': '当前欠费数量',
    '总欠费额': '总欠费额',
    '交款退款': '交款退款',
    '抄收与设置': '抄收与设置',
    '账单流水': '账单流水',
    '序号': '序号',
    '表具编号': '表号',
    '用户名称': '用户名称',
    '位置': '位置',
    '阀门状态': '阀门状态',
    '异常原因': '异常原因',
    '查看': '查看',
    '本月': '本月',
    '微信缴费金额': '微信缴费金额',
    '业务售水金额': '业务售水金额',
    '优惠售水金额': '优惠售水金额',
    '系统结转金额': '系统结转金额',
    '平台退费金额': '平台退费金额',
    '缴费编号': '缴费编号',
    '水表编号': '水表编号',
    '余额': '余额',
    '地址': '地址',
  },
  // 交款退款
  'accountMent': {
    'projectHome': '项目首页',
    'paymentRefund': '交款退款',
    'batchPayment': '批量缴款',
    'batchRefund': '批量退款',
    'paymentId': '缴费编号',
    'meterNumber': '水表编号',
    'userName': '用户姓名',
    'contactInfo': '联系方式',
    'address': '地址',
    'balance': '余额',
    'operation': '操作',
    'payment': '缴款',
    'refund': '退款',
    'waterFeePayment': '水费交款',
    'waterFeeRefund': '水费退款',
    'currentSelection': '当前勾选',
    'devices': '台设备',
    'selectAllDevices': '选择当前区域所有设备',
    'records': '条',
    'paymentAmount': '交款',
    'refundAmount': '退款',
    'confirm': '确定',
    'cancel': '取消',
    'note': '备注',
    'refundableAmount': '可退款金额',
    'refundNote': '注：退费金额=余额-其它收费金额',
    'rechargeVoucher': '充值凭证',
    'orderNumber': '订单编号',
    'receiptDate': '收款日期',
    'deviceNumber': '设备编号',
    'currentMeterReading': '当前表码',
    'addressInfo': '地址信息',
    'rechargeAmount': '充值金额',
    'accountBalance': '账户余额',
    'operator': '操作人员',
    'mobileScreenshot': '手机可以截个图作为凭证',
    'print': '打印',
    'businessWaterSales': '业务售水',
    'discountWaterSales': '优惠售水',
    'systemTransfer': '系统结转',
    'pleaseEnterAmount': '请输入金额',
    '项目首页': '项目首页',
    '交款退款': '交款退款',
    '批量缴款': '批量缴款',
    '批量退款': '批量退款',
    '缴费编号': '缴费编号',
    '水表编号': '水表编号',
    '用户姓名': '用户姓名',
    '联系方式': '联系方式',
    '地址': '地址',
    '余额': '余额',
    '操作': '操作',
    '缴款': '缴款',
    '退款': '退款',
    '水费交款': '水费交款',
    '当前勾选': '当前勾选',
    '台设备': '台设备',
    '选择当前区域所有设备': '选择当前区域所有设备',
    '条': '条',
    '交款': '交款',
    '请输入金额': '请输入金额',
    '确定': '确定',
    '备注': '备注',
    '水费退款': '水费退款',
    '可退款金额': '可退款金额',
    '注：退费金额=余额-其它收费金额': '注：退费金额=余额-其它收费金额',
    '充值凭证': '充值凭证',
    '订单编号': '订单编号',
    '收款日期': '收款日期',
    '设备编号': '设备编号',
    '当前表码': '当前表码',
    '地址信息': '地址信息',
    '充值金额': '充值金额',
    '账户余额': '账户余额',
    '操作人员': '操作人员',
    '手机可以截个图作为凭证': '手机可以截个图作为凭证',
    '打印': '打印',
    '取消': '取消',
  },
  // 水表接收与设置
  'waterMeter': {
    'projectHome': '项目首页',
    'waterMeterSetting': '水表接收与设置',
    'search': '请搜索关键字点击输入进行查询',
    'searchBtn': '查询',
    'resetBtn': '重选',
    'community': '小区',
    'selectCommunity': '请选择小区',
    'building': '楼栋',
    'selectBuilding': '请选择楼栋',
    'unit': '单元',
    'selectUnit': '请选择单元',
    'room': '房间',
    'selectRoom': '请选择房间',
    '余额': '余额',
    '请选择状态': '请选择状态',
    'valveControl': '阀门控制',
    'openValve': '开阀',
    'closeValve': '关阀',
    'alarmCloseValve': '报警关阀',
    'valveTest': '阀门测试',
    'cyclicUploadParam': '周期上传参数',
    'fixedUploadParam': '定点上传参数',
    'dailyFreezeParam': '日冻结参数',
    'monthlyFreezeParam': '月冻结参数',
    'dailyFreezeData': '日冻结数据',
    'monthlyFreezeData': '月冻结数据',
    'areaExport': '区域导出',
    '缴费编号': '缴费编号',
    '水表编号': '水表编号',
    '表号': '表号',
    '用户名': '用户名',
    '余额': '余额',
    '位置': '位置',
    '最新上报时间': '最新上报时间',
    '正向累计流量': '正向累计流量',
    '净累计流量': '净累计流量',
    '反向累计流量': '反向累计流量',
    '瞬时流量': '瞬时流量',
    '电池电压': '电池电压',
    '信号强度': '信号强度',
    '上传失败次数': '上传失败次数',
    '定时冻结间隔': '定时冻结间隔',
    '压力': '压力',
    '水温': '水温',
    '掉电状态': '掉电状态',
    '低压状态': '低压状态',
    '阀门状态': '阀门状态',
    '磁攻击': '磁攻击',
    '拆卸状态': '拆卸状态',
    '漏水报警': '漏水报警',
    '反向计量': '反向计量',
    '流量超限': '流量超限',
    '液位报警': '液位报警',
    'operation': '操作',
    'queryProcessSettings': '设备进程',
    'waterUsageCurve': '用水曲线',
    'queryHistoryRecord': '历史记录',
    'QueryDailyUsage': '设备日用量',
    'enterMeterReading': '录入表码',
    'noData': '暂无数据',
    // 弹窗
    'openValveDevice': '开阀设备',
    'currentSelected': '当前勾选',
    'devices': '台设备',
    'selectAllDevices': '选择当前区域所有设备',
    'records': '条',
    'submit': '提交',
    'cancel': '取消',
    // 查询进程
    'queryProcess': '查询进程',
    'deviceNumber': '设备编号',
    'index': '序号',
    'meterNumber': '表号',
    'operationContent': '操作内容',
    'operationResult': '操作结果',
    'createTime': '创建时间',
    'sendTime': '发送时间',
    'completeTime': '完成时间',
    '响应结果': '响应结果',
    // 定点上传
    'fixedUpload': '定点上传',
    'every': '每',
    'month': '月',
    'day': '日',
    'hour': '时',
    'upload': '上传',
    'note': '注: 如果后面不选择的话就取消定点上传功能',
    // 周期上传
    'cyclicUpload': '周期上传',
    'uploadTime': '上传时间',
    'to': '至',
    'startTime': '开始时间',
    'endTime': '结束时间',
    'selectTimeRange': '选择时间范围',
    'uploadInterval': '上传间隔',
    // 冻结数据
    'selectDate': '选择日期',
    'freezeTime': '冻结时间',
    'uploadDate': '上传日期',
    'selectMonth': '选择月',
    // 冻结参数
    'dailyFreezeTime': '日冻结时间',
    'selectTime': '选择时间',
    'monthlyFreezeTime': '月冻结时间',
    'of': '的',
    // 历史记录
    'historyRecord': '历史记录',
    'totalUsage': '累计总用量',
    'meterReadingTime': '抄表时间',
    // 用水曲线
    // 录入表码
    'meterReading': '表码数',
    'save': '保存',
    '请搜索关键字点击输入进行查询': '请搜索关键字点击输入进行查询',
    '查询': '查询',
    '重选': '重选',
    '小区': '小区',
    '请选择小区': '请选择小区',
    '楼栋': '楼栋',
    '请选择楼栋': '请选择楼栋',
    '单元': '单元',
    '请选择单元': '请选择单元',
    '房间': '房间',
    '请选择房间': '请选择房间',
    '项目首页': '项目首页',
    '接收与设置': '接收与设置',
    '阀门控制': '阀门控制',
    '开阀': '开阀',
    '关阀': '关阀',
    '报警关阀': '报警关阀',
    '阀门测试': '阀门测试',
    '周期上传参数': '周期上传参数',
    '定点上传参数': '定点上传参数',
    '日冻结参数': '日冻结参数',
    '月冻结参数': '月冻结参数',
    '日冻结数据': '日冻结数据',
    '月冻结数据': '月冻结数据',
    '区域导出': '区域导出',
    '操作': '操作',
    '设备进程': '设备进程',
    '用水曲线': '用水曲线',
    '历史记录': '历史记录',
    '设备日用量': '设备日用量',
    '录入表码': '录入表码',
    '开阀设备': '开阀设备',
    '当前勾选': '当前勾选',
    '台设备': '台设备',
    '选择当前区域所有设备': '选择当前区域所有设备',
    '条': '条',
    '取消': '取消',
    '提交': '提交',
    '查询进程': '查询进程',
    '设备编号': '设备编号',
    '序号': '序号',
    '表具编号': '表号',
    '水表编号': '水表编号',
    '操作内容': '操作内容',
    '操作结果': '操作结果',
    '创建时间': '创建时间',
    '发送时间': '发送时间',
    '完成时间': '完成时间',
    '定点上传': '定点上传',
    '每': '每',
    '月': '月',
    '日': '日',
    '的': '的',
    '时': '时',
    '上传': '上传',
    '注: 如果后面不选择的话就取消定点上传功能': '注: 如果后面不选择的话就取消定点上传功能',
    '周期上传': '周期上传',
    '上传时间': '上传时间',
    '至': '至',
    '开始时间': '开始时间',
    '结束时间': '结束时间',
    '选择时间范围': '选择时间范围',
    '上传间隔': '上传间隔',
    '选择日期': '选择日期',
    '冻结时间': '冻结时间',
    '上传日期': '上传日期',
    '选择月': '选择月',
    '日冻结时间': '日冻结时间',
    '选择时间': '选择时间',
    '月冻结时间': '月冻结时间',
    '累计总用量': '累计总用量',
    '抄表时间': '抄表时间',
    '暂无数据': '暂无数据',
    '表码数': '表码数',
    '保存': '保存',
  },
  // 查询设备与抄收---查询设备日用水
  'QueryDailyUsage': {
    '表号': '表号',
    '水表编号': '水表编号',
    '统计日期': '统计日期',
    '当日用量': '当日用量',
    '当前表码数': '当前表码数',
    '是否结算': '是否结算',
    '设备日用量': '设备日用量',
    '重置': '重置',
    '是': '是',
    '否': '否',
    '至': '至',
    '开始日期': '开始日期',
    '结束日期': '结束日期'
  },
  // 财务报表 - 充值记录
  'financialReport': {
    'projectHome': '项目首页',
    'financialReport': '账务报表',
    'rechargeRecord': '充值记录',
    'search': '请输入关键字',
    'areaExport': '区域导出',
    'paymentId': '缴费编号',
    'meterNumber': '水表编号',
    'username': '用户姓名',
    'address': '地址',
    'time': '时间',
    'amount': '交/退款金额',
    'billType': '账单类型',
    'status': '状态',
    'note': '备注',
    'operation': '操作',
    'print': '打印',
    'rechargeVoucher': '充值凭证',
    'orderNumber': '订单编号',
    'receiptDate': '收款日期',
    'deviceNumber': '设备编号',
    'currentMeterReading': '当前表码',
    'addressInfo': '地址信息',
    'rechargeAmount': '充值金额',
    'accountBalance': '账户余额',
    'operator': '操作人员',
    'mobileScreenshot': '手机可以截个图作为凭证',
    'cancel': '取消',
    '请输入关键字': '请输入关键字',
    '项目首页': '项目首页',
    '账务报表': '账务报表',
    '充值记录': '充值记录',
    '区域导出': '区域导出',
    '缴费编号': '缴费编号',
    '水表编号': '水表编号',
    '用户姓名': '用户姓名',
    '地址': '地址',
    '时间': '时间',
    '交/退款金额': '交/退款金额',
    '账单类型': '账单类型',
    '状态': '状态',
    '备注': '备注',
    '操作': '操作',
    '打印': '打印',
    '充值凭证': '充值凭证',
    '订单编号': '订单编号',
    '收款日期': '收款日期',
    '设备编号': '设备编号',
    '当前表码': '当前表码',
    '地址信息': '地址信息',
    '充值金额': '充值金额',
    '账户余额': '账户余额',
    '操作人员': '操作人员',
    '手机可以截个图作为凭证': '手机可以截个图作为凭证',
    '取消': '取消',
  },
  // 财务报表 账单流水
  'BillFlow': {
    'projectHome': '项目首页',
    'financialReport': '财务报表',
    'BillFlow': '账单流水',
    'RegionalExport': '区域导出',
    'paymentId': '缴费编号',
    'meterNumber': '水表编号',
    'username': '用户姓名',
    'time': '时间',
    'amount': '本次金额',
    'userAddress': '用户地址',
    'settlementWaterVolume': '结算水量',
    'meterReading': '表码数',
    'balance': '余额',
    'billType': '账单类型',
    'status': '状态',
    'note': '备注',
    'operation': '操作',
    'cancel': '撤销',
    'confirm': '确定',
    'serialNumber': '序号',
    'contactInfo': '联系方式',
    'waterType': '用水类型',
    'onlineStatus': '在线状态',
    'valveStatus': '阀门状态',
    'positiveFlow': '正向累计流量',
    'netFlow': '净累计流量',
    'idNumber': '证件号码',
    'cancelSuccess': '撤销成功',
    'BillFlowAreaInfoTable': '账单流水区域信息表',
    'exportSuccess': '导出成功!',
    '项目首页': '项目首页',
    '财务报表': '财务报表',
    '账单流水': '账单流水',
    '区域导出': '区域导出',
    '缴费编号': '缴费编号',
    '水表编号': '水表编号',
    '用户姓名': '用户姓名',
    '时间': '时间',
    '本次金额': '本次金额',
    '用户地址': '用户地址',
    '结算水量': '结算水量',
    '表码数': '表码数',
    '余额': '余额',
    '账单类型': '账单类型',
    '状态': '状态',
    '备注': '备注',
    '操作': '操作',
    '撤销': '撤销',
    '确定': '确定',
    '序号': '序号',
    '联系方式': '联系方式',
    '用水类型': '用水类型',
    '在线状态': '在线状态',
    '阀门状态': '阀门状态',
    '正向累计流量': '正向累计流量',
    '净累计流量': '净累计流量',
    '证件号码': '证件号码',
    '撤销成功': '撤销成功',
    '账单流水区域信息表': '账单流水区域信息表',
    '导出成功!': '导出成功!',
  },
  // 售水日报
  'waterSalesDaily': {
    'projectHome': '项目首页',
    'financialReport': '账务报表',
    'waterSalesDaily': '售水日报',
    'totalWechatPayAmount': '总微信支付金额',
    'totalWechatPayCount': '总微信支付次数',
    'totalBusinessWaterAmount': '总业务售水金额',
    'totalBusinessWaterCount': '总业务售水次数',
    'totalDiscountWaterAmount': '总优惠售水金额',
    'totalDiscountWaterCount': '总优惠售水次数',
    'totalSystemTransferAmount': '总系统结转金额',
    'totalSystemTransferCount': '总系统结转次数',
    'totalPlatformRefundAmount': '总平台退费金额',
    'totalPlatformRefundCount': '总平台退费次数',
    'wechatPayAmount': '微信支付金额',
    'wechatPayCount': '微信支付次数',
    'businessWaterAmount': '业务售水金额',
    'businessWaterCount': '业务售水次数',
    'discountWaterAmount': '优惠售水金额',
    'discountWaterCount': '优惠售水次数',
    'systemTransferAmount': '系统结转金额',
    'systemTransferCount': '系统结转次数',
    'platformRefundAmount': '平台退费金额',
    'platformRefundCount': '平台退费次数',
    'statisticalTime': '统计时间',
    'to': '至',
    'startDate': '开始日期',
    'endDate': '结束日期',
    'community': '小区',
    'selectCommunity': '请选择小区',
    'building': '楼栋',
    'selectBuilding': '请选择楼栋',
    'unit': '单元',
    'selectUnit': '请选择单元',
    'room': '房间',
    'selectRoom': '请选择房间',
    'search': '查 询',
    'reset': '重 置',
    '至': '至',
    '开始日期': '开始日期',
    '结束日期': '结束日期',
    '小区': '小区',
    '请选择小区': '请选择小区',
    '楼栋': '楼栋',
    '请选择楼栋': '请选择楼栋',
    '单元': '单元',
    '请选择单元': '请选择单元',
    '房间': '房间',
    '请选择房间': '请选择房间',
    '查询': '查 询',
    '重置': '重 置',
    '项目首页': '项目首页',
    '账务报表': '账务报表',
    '售水日报': '售水日报',
    '总微信支付金额': '总微信支付金额',
    '总微信支付次数': '总微信支付次数',
    '总业务售水金额': '总业务售水金额',
    '总业务售水次数': '总业务售水次数',
    '总优惠售水金额': '总优惠售水金额',
    '总优惠售水次数': '总优惠售水次数',
    '总系统结转金额': '总系统结转金额',
    '总系统结转次数': '总系统结转次数',
    '总平台退费金额': '总平台退费金额',
    '总平台退费次数': '总平台退费次数',
    '微信支付金额': '微信支付金额',
    '微信支付次数': '微信支付次数',
    '业务售水金额': '业务售水金额',
    '业务售水次数': '业务售水次数',
    '优惠售水金额': '优惠售水金额',
    '优惠售水次数': '优惠售水次数',
    '系统结转金额': '系统结转金额',
    '系统结转次数': '系统结转次数',
    '平台退费金额': '平台退费金额',
    '平台退费次数': '平台退费次数',
    '统计时间': '统计时间',
  },
  // 售水月报
  'waterSalesMonthly': {
    'startMonth': '开始月份',
    'endMonth': '结束月份',
    'community': '小区',
    'selectCommunity': '请选择小区',
    'building': '楼栋',
    'selectBuilding': '请选择楼栋',
    'unit': '单元',
    'selectUnit': '请选择单元',
    'room': '房间',
    'selectRoom': '请选择房间',
    'search': '查 询',
    'reset': '重 置',
    'totalWechatAmount': '总微信支付金额',
    'totalWechatCount': '总微信支付次数',
    'totalBusinessAmount': '总业务售水金额',
    'totalBusinessCount': '总业务售水次数',
    'totalDiscountAmount': '总优惠售水金额',
    'totalDiscountCount': '总优惠售水次数',
    'totalSystemAmount': '总系统结转金额',
    'totalSystemCount': '总系统结转次数',
    'totalRefundAmount': '总平台退费金额',
    'totalRefundCount': '总平台退费次数',
    'wechatAmount': '微信支付金额',
    'wechatCount': '微信支付次数',
    'businessAmount': '业务售水金额',
    'businessCount': '业务售水次数',
    'discountAmount': '优惠售水金额',
    'discountCount': '优惠售水次数',
    'systemAmount': '系统结转金额',
    'systemCount': '系统结转次数',
    'refundAmount': '平台退费金额',
    'refundCount': '平台退费次数',
    'statisticsTime': '统计时间',
    'selectTime': '请选择时间',
    '开始月份': '开始月份',
    '结束月份': '结束月份',
    '小区': '小区',
    '请选择小区': '请选择小区',
    '楼栋': '楼栋',
    '请选择楼栋': '请选择楼栋',
    '单元': '单元',
    '请选择单元': '请选择单元',
    '房间': '房间',
    '请选择房间': '请选择房间',
    '查询': '查 询',
    '重置': '重 置',
    '总微信支付金额': '总微信支付金额',
    '总微信支付次数': '总微信支付次数',
    '总业务售水金额': '总业务售水金额',
    '总业务售水次数': '总业务售水次数',
    '总优惠售水金额': '总优惠售水金额',
    '总优惠售水次数': '总优惠售水次数',
    '总系统结转金额': '总系统结转金额',
    '总系统结转次数': '总系统结转次数',
    '总平台退费金额': '总平台退费金额',
    '总平台退费次数': '总平台退费次数',
    '微信支付金额': '微信支付金额',
    '微信支付次数': '微信支付次数',
    '业务售水金额': '业务售水金额',
    '业务售水次数': '业务售水次数',
    '优惠售水金额': '优惠售水金额',
    '优惠售水次数': '优惠售水次数',
    '系统结转金额': '系统结转金额',
    '系统结转次数': '系统结转次数',
    '平台退费金额': '平台退费金额',
    '平台退费次数': '平台退费次数',
    '统计时间': '统计时间',
    '请选择时间': '请选择时间',
  },
  // 售水年报
  'annualReport': {
    'selectTime': '选择时间',
    'selectYear': '选择年',
    'community': '小区',
    'selectCommunity': '请选择小区',
    'building': '楼栋',
    'selectBuilding': '请选择楼栋',
    'unit': '单元',
    'selectUnit': '请选择单元',
    'room': '房间',
    'selectRoom': '请选择房间',
    'search': '查 询',
    'reset': '重 置',
    'totalWechatPayAmount': '总微信支付金额',
    'totalWechatPayCount': '总微信支付次数',
    'totalBusinessWaterAmount': '总业务售水金额',
    'totalBusinessWaterCount': '总业务售水次数',
    'totalDiscountWaterAmount': '总优惠售水金额',
    'totalDiscountWaterCount': '总优惠售水次数',
    'totalSystemTransferAmount': '总系统结转金额',
    'totalSystemTransferCount': '总系统结转次数',
    'totalPlatformRefundAmount': '总平台退费金额',
    'totalPlatformRefundCount': '总平台退费次数',
    'wechatPayAmount': '微信支付金额',
    'wechatPayCount': '微信支付次数',
    'businessWaterAmount': '业务售水金额',
    'businessWaterCount': '业务售水次数',
    'discountWaterAmount': '优惠售水金额',
    'discountWaterCount': '优惠售水次数',
    'systemTransferAmount': '系统结转金额',
    'systemTransferCount': '系统结转次数',
    'platformRefundAmount': '平台退费金额',
    'platformRefundCount': '平台退费次数',
    'statisticsTime': '统计时间',
    'selectTimeError': '请选择时间',
    '选择时间': '选择时间',
    '选择年': '选择年',
    '小区': '小区',
    '请选择小区': '请选择小区',
    '楼栋': '楼栋',
    '请选择楼栋': '请选择楼栋',
    '单元': '单元',
    '请选择单元': '请选择单元',
    '房间': '房间',
    '请选择房间': '请选择房间',
    '查询': '查 询',
    '重置': '重 置',
    '总微信支付金额': '总微信支付金额',
    '总微信支付次数': '总微信支付次数',
    '总业务售水金额': '总业务售水金额',
    '总业务售水次数': '总业务售水次数',
    '总优惠售水金额': '总优惠售水金额',
    '总优惠售水次数': '总优惠售水次数',
    '总系统结转金额': '总系统结转金额',
    '总系统结转次数': '总系统结转次数',
    '总平台退费金额': '总平台退费金额',
    '总平台退费次数': '总平台退费次数',
    '微信支付金额': '微信支付金额',
    '微信支付次数': '微信支付次数',
    '业务售水金额': '业务售水金额',
    '业务售水次数': '业务售水次数',
    '优惠售水金额': '优惠售水金额',
    '优惠售水次数': '优惠售水次数',
    '系统结转金额': '系统结转金额',
    '系统结转次数': '系统结转次数',
    '平台退费金额': '平台退费金额',
    '平台退费次数': '平台退费次数',
    '统计时间': '统计时间',
    '请选择时间': '请选择时间',
  },
  // 用水类型管理
  'waterType': {
    'projectHome': '项目首页',
    'basicData': '基础资料',
    'waterType': '用水类型',
    'waterTypeManagement': '用水类型管理',
    'addWaterType': '新增用水类型',
    'loading': '拼命加载中',
    'waterTypeName': '用水类型',
    'ladderType': '阶梯类型',
    'fixed': '固定',
    'ladder': '阶梯',
    'monthlyFixedFee': '月固定费',
    'monthlyIncludedWater': '月含水量',
    'operation': '操作',
    'delete': '删除',
    'view': '查看',
    // 添加对话框
    'addLadder': '新增阶梯',
    'name': '名称',
    'waterTypePlaceholder': '用水类型',
    'monthlyFee': '月固定费',
    'yuan': '元',
    'includedWater': '含水量',
    'cubicMeter': '方',
    'feeNote': '注: 如果输入0元则是0元',
    // 阶梯类型标签
    'flatPrice': '平价',
    'monthlyLadder': '月阶梯',
    'annualLadder': '年阶梯',
    // 阶梯表单
    'ladderOne': '阶梯一',
    'ladderTwo': '阶梯二',
    'ladderThree': '阶梯三',
    'ladderFour': '阶梯四',
    'ladderFive': '阶梯五',
    'price': '价格',
    'inputStageOne': '请输入阶段一',
    'inputStageTwo': '请输入阶段二',
    'inputStageThree': '请输入阶段三',
    'inputStageFour': '请输入阶段四',
    'inputStageFive': '请输入阶段五',
    'inputPrice': '请输入价格',
    'flatPriceNote': '注: 如要添加平价，需要点击平价后则可进行输入。',
    // 按钮
    'reselect': '重 选',
    'save': '保 存',
    // 查看对话框
    'viewDetails': '查看详情',
    'modify': '修 改',
    'close': '关闭',
    'modifyNote': '注: 如要修改平价/月阶梯或年阶梯，需要在点击修改前选择好要修改的平价/月阶梯或年阶梯则可进行修改。',
    // 提示框
    'confirmDelete': '此操作将永久删除该阶梯, 是否继续?',
    'tip': '提示',
    'confirm': '确定',
    'cancel': '取消',
    'deleteSuccess': '删除成功',
    'cancelDelete': '已取消删除',
    'addSuccess': '添加成功',
    'modifySuccess': '修改成功',
    '元': '元',
    '项目首页': '项目首页',
    '基础资料': '基础资料',
    '用水类型': '用水类型',
    '用水类型管理': '用水类型管理',
    '新增用水类型': '新增用水类型',
    '拼命加载中': '拼命加载中',
    '阶梯类型': '阶梯类型',
    '固定': '固定',
    '阶梯': '阶梯',
    '月固定费': '月固定费',
    '月含水量': '月含水量',
    '操作': '操作',
    '删除': '删除',
    '查看': '查看',
    '新增阶梯': '新增阶梯',
    '名称': '名称',
    '含水量': '含水量',
    '方': '方',
    '注:如果输入0元则是0元': '注: 如果输入0元则是0元',
    '平价': '平价',
    '月阶梯': '月阶梯',
    '阶梯一': '阶梯一',
    '请输入阶段一': '阶梯',
    '价格': '价格',
    '请输入价格': '请输入价格',
    '阶梯二': '阶梯二',
    '请输入阶段二': '请输入阶段二',
    '阶梯三': '阶梯三',
    '请输入阶段三': '请输入阶段三',
    '阶梯四': '阶梯四',
    '请输入阶段四': '请输入阶段四',
    '阶梯五': '阶梯五',
    '请输入阶段五': '请输入阶段五',
    '年阶梯': '年阶梯',
    '注:如要添加平价，需要点击平价后则可进行输入。': '注: 如要添加平价，需要点击平价后则可进行输入。',
    '重选': '重 选',
    '保存': '保 存',
    '查看详情': '查看详情',
    '注:如要修改平价/月阶梯或年阶梯，需要在点击修改前选择好要修改的平价/月阶梯或年阶梯则可进行修改。': '注: 如要修改平价/月阶梯或年阶梯，需要在点击修改前选择好要修改的平价/月阶梯或年阶梯则可进行修改。',
    '修改': '修 改',
    '关闭': '关闭',
    '修改成功': '修改成功',
    '添加成功': '添加成功',
    '此操作将永久删除该阶梯, 是否继续?': '此操作将永久删除该阶梯, 是否继续?',
    '提示': '提示',
    '确定': '确定',
    '取消': '取消',
    '删除成功': '删除成功',
    '已取消删除': '已取消删除',
  },
  // 基础资料————位置信息
  'positionInfo': {
    'projectHome': '项目首页',
    'basicData': '基础资料',
    'locationInfo': '位置信息',
    '小区': '小区',
    '楼栋': '楼栋',
    '单元': '单元',
    '房间': '房间',
    'search': '请搜索',
    'query': '查询',
    'add': '添加',
    '修改': '修改',
    'delete': '删除',
    '小区名称': '小区名称',
    '楼栋名称': '楼栋名称',
    'unitName': '单元名称',
    'roomName': '房间名称',
    'operation': '操作',
    'infoEdit': '信息编辑',
    '信息修改': '信息修改',
    'save': '保存',
    '请选择小区': '请选择小区',
    'selectBuilding': '请选择楼栋',
    'confirmDelete': '此操作将永久删除该位置, 是否继续?',
    'tip': '提示',
    'confirm': '确定',
    'cancel': '取消',
    'deleteSuccess': '删除成功',
    'cancelDelete': '已取消删除',
    'addSuccess': '添加成功',
    'modifySuccess': '修改成功',
    '项目首页': '项目首页',
    '基础资料': '基础资料',
    '位置信息': '位置信息',
    '请搜索': '请搜索',
    '查询': '查询',
    '添加': '添加',
    '操作': '操作',
    '删除': '删除',
    '单元名称': '单元名称',
    '房间名称': '房间名称',
    '保存': '保存',
    '请选择楼栋': '请选择楼栋',
    '信息编辑': '信息编辑',
    '此操作将永久删除该位置, 是否继续?': '此操作将永久删除该位置, 是否继续?',
    '提示': '提示',
    '确定': '确定',
    '取消': '取消',
    '删除成功': '删除成功',
    '已取消删除': '已取消删除',
    '添加成功': '添加成功',
    '修改成功': '修改成功',
  },
  // 表具类型
  'gaugetype': {
    'projectHome': '项目首页',
    'basicData': '基础资料',
    'meterType': '表具类型',
    'model': '型号',
    'add': '添加',
    'modify': '修改',
    'delete': '删除',
    'infoEdit': '信息编辑',
    'save': '保存',
    'confirmDelete': '此操作将永久删除该表具类型, 是否继续?',
    'tip': '提示',
    'confirm': '确定',
    'cancel': '取消',
    'cancelDelete': '已取消删除',
    '项目首页': '项目首页',
    '基础资料': '基础资料',
    '表具类型': '表具类型',
    '添加': '添加',
    '型号': '型号',
    '修改': '修改',
    '删除': '删除',
    '信息编辑': '信息编辑',
    '保存': '保存',
    '此操作将永久删除该表具类型, 是否继续?': '此操作将永久删除该表具类型, 是否继续?',
    '提示': '提示',
    '确定': '确定',
    '取消': '取消',
    '已取消删除': '已取消删除',
  },
  // 水表档案
  'waterMeterFile': {
    '项目首页': '项目首页',
    'basicData': '基础资料',
    'waterMeterFile': '水表档案',
    '批量添加': '批量添加',
    '单条添加': '单条添加',
    'selectedExport': '选中导出',
    'areaExport': '区域导出',
    'batchEnable': '批量启用',
    'batchDisable': '批量停用',
    'addValveControlWhitelist': '添加阀控策略白名单',
    '缴费编号': '缴费编号',
    '水表编号': '水表编号',
    '用户姓名': '用户姓名',
    '联系方式': '联系方式',
    '余额': '余额',
    '启用状态': '启用状态',
    '用水类型': '用水类型',
    '在线状态': '在线状态',
    '阀门状态': '阀门状态',
    '上传失败次数': '上传失败次数',
    '定时冻结间隔': '定时冻结间隔',
    '压力': '压力',
    '水温': '水温',
    '用户地址': '用户地址',
    '正向累计流量': '正向累计流量',
    '净累计流量': '净累计流量',
    '证件号码': '证件号码',
    '拆卸状态': '拆卸状态',
    '漏水': '漏水',
    '反向计量': '反向计量',
    '流量超限': '流量超限',
    '液位报警': '液位报警',
    'operation': '操作',
    '修改': '修改',
    'view': '查看',
    'enabled': '启用',
    'disabled': '停用',
    'selectWaterType': '请选择',
    // 批量导入弹窗
    'dragOrClick': '将文件拖到此处，或点击上传',
    'onlyUploadXls': '只能上传xls/xlsx文件',
    'downloadTemplate': '点击下载模板文件',
    // 批量添加结果弹窗
    'successCount': '成功条数',
    'failCount': '失败条数',
    'errorInfo': '错误信息',
    // 批量启用/停用弹窗
    'currentSelection': '当前勾选',
    'devices': '台设备',
    'selectAllDevices': '选择当前区域所有设备',
    'records': '条',
    'waterTypeLabel': '用水类型',
    // 添加白名单弹窗
    'whitelistDescription': '说明：阀控策略白名单内的表将不会自动关阀',
    'add': '添加',
    '基础资料': '基础资料',
    '水表档案': '水表档案',
    '批量启用': '批量启用',
    '批量停用': '批量停用',
    '添加阀控策略白名单': '添加阀控策略白名单',
    '选中导出': '选中导出',
    '区域导出': '区域导出',
    '停用': '停用',
    '启用': '启用',
    '操作': '操作',
    '查看': '查看',
    '将文件拖到此处，或点击上传': '将文件拖到此处，或点击上传',
    '只能上传xls/xlsx文件': '只能上传xls/xlsx文件',
    '点击下载模板文件': '点击下载模板文件',
    '成功条数': '成功条数',
    '失败条数': '失败条数',
    '错误信息': '错误信息',
    '当前勾选': '当前勾选',
    '台设备': '台设备',
    '选择当前区域所有设备': '选择当前区域所有设备',
    '条': '条',
    '请选择': '请选择',
    '说明：阀控策略白名单内的表将不会自动关阀': '说明：阀控策略白名单内的表将不会自动关阀',
    '添加': '添加',
  },
  // 水表地址组件
  'waterAddress': {
    'community': '小区',
    'selectCommunity': '请选择小区',
    'building': '楼栋',
    'selectBuilding': '请选择楼栋',
    'unit': '单元',
    'selectUnit': '请选择单元',
    'room': '房间',
    'selectRoom': '请选择房间',
    'owingStatus': '欠费状态',
    'pleaseSelectWhetherOwing': '请选择是否欠费',
    'all': '全部',
    'owing': '欠费',
    'notOwing': '不欠费',
    'waterType': '用水类型',
    'pleaseSelect': '请选择',
    'search': '查询',
    'reset': '重置',
    '查询': '查询',
    '重置': '重置',
    '用水类型': '用水类型',
    '请选择': '请选择',
    '欠费状态': '欠费状态',
    '请选择是否欠费': '请选择是否欠费',
    '小区': '小区',
    '请选择小区': '请选择小区',
    '楼栋': '楼栋',
    '请选择楼栋': '请选择楼栋',
    '单元': '单元',
    '请选择单元': '请选择单元',
    '房间': '房间',
    '请选择房间': '请选择房间',
    '全部': '全部',
    '欠费': '欠费',
    '不欠费': '不欠费',
  },
  // 水表档案--单条添加
  'waterAddition': {
    'meterIdLabel': '表具编码 : ',
    'enterMeterId': '请输入表具编码',
    'modelLabel': '型号 : ',
    'selectModel': '请选择型号',
    'waterTypeLabel': '用水类型 : ',
    'selectWaterType': '请选择用水类型',
    'meterStatusLabel': '水表状态 : ',
    'selectMeterStatus': '请选择水表状态',
    'nameLabel': '姓名:',
    'enterName': '请输入姓名',
    'phoneLabel': '联系电话:',
    'enterPhone': '请输入电话',
    'idCardLabel': '证件号码:',
    'enterIdCard': '请输入证件号码',
    'communityLabel': '小区:',
    'selectCommunity': '请选择小区',
    'buildingLabel': '楼栋:',
    'selectBuilding': '请选择楼栋',
    'unitLabel': '单元:',
    'selectUnit': '请选择单元',
    'roomLabel': '房间:',
    'selectRoom': '请选择房间',
    'save': '保 存',
    'infoEdit': '信息编辑',
    'communityNameLabel': '小区名称: ',
    'buildingNameLabel': '楼栋名称 : ',
    'unitNameLabel': '单元名称 : ',
    'roomNameLabel': '房间名称 : ',
    'addSuccess': '添加成功',
    'addCommunitySuccess': '添加小区成功',
    'addBuildingSuccess': '添加楼栋成功',
    'addUnitSuccess': '添加单元成功',
    'addRoomSuccess': '添加楼房间成功',
    '表具编码': '表具编码 : ',
    '水表编号': '水表编号:',
    '请输入水表编号': '请输入水表编号',
    '型号': '型号 : ',
    '请选择型号': '请选择型号',
    '用水类型': '用水类型 : ',
    '请选择用水类型': '请选择用水类型',
    '水表状态': '水表状态 : ',
    '请选择水表状态': '请选择水表状态',
    '姓名': '姓名:',
    '请输入姓名': '请输入姓名',
    '联系电话': '联系电话:',
    '请输入电话': '请输入电话',
    '证件号码': '证件号码:',
    '请输入证件号码': '请输入证件号码',
    '小区': '小区:',
    '请选择小区': '请选择小区',
    '楼栋': '楼栋:',
    '请选择楼栋': '请选择楼栋',
    '单元': '单元:',
    '请选择单元': '请选择单元',
    '房间': '房间:',
    '请选择房间': '请选择房间',
    '保存': '保 存',
    '信息编辑': '信息编辑',
    '小区名称: ': '小区名称: ',
    '楼栋名称': '楼栋名称 : ',
    '单元名称': '单元名称 : ',
    '房间名称': '房间名称 : ',
    '添加成功': '添加成功',
    '添加小区成功': '添加小区成功',
    '添加楼栋成功': '添加楼栋成功',
    '添加单元成功': '添加单元成功',
    '添加楼房间成功': '添加楼房间成功',
  },
  // 水表档案--修改
  'modify': {
    'title': '解绑水表',
    'meterCode': '表具编码 : ',
    'enterMeterCode': '请输入表具编码',
    'modelType': '型号 : ',
    'selectWaterType': '请选择用水类型',
    'waterType': '用水类型 : ',
    'meterStatus': '水表状态 : ',
    'selectMeterStatus': '请选择水表状态',
    'userName': '姓名:',
    'enterName': '请输入姓名',
    'contactPhone': '联系电话:',
    'enterPhone': '请输入电话',
    'idNumber': '证件号码:',
    'enterId': '请输入证件号码',
    'community': '小区:',
    'selectCommunity': '请选择小区',
    'building': '楼栋:',
    'selectBuilding': '请选择楼栋',
    'unit': '单元:',
    'selectUnit': '请选择单元',
    'room': '房间:',
    'selectRoom': '请选择房间',
    'locationNote': '注：如果不选择位置则保存之前的位置',
    'save': '保 存',
    'disabled': '停用',
    'enabled': '启用',
    'infoEdit': '信息编辑',
    'communityName': '小区名称: ',
    'buildingName': '楼栋名称 : ',
    'unitName': '单元名称 : ',
    'roomName': '房间名称 : ',
    'successTitle': '成功',
    'modifySuccess': '修改成功',
    'addCommunitySuccess': '添加小区成功',
    'addBuildingSuccess': '添加楼栋成功',
    'addUnitSuccess': '添加单元成功',
    'addRoomSuccess': '添加楼房间成功',
    '表具编码': '表具编码 : ',
    '水表编号':'水表编号',
    '请输入水表编号': '请输入水表编号',
    '型号': '型号 : ',
    '请选择用水类型': '请选择用水类型',
    '用水类型': '用水类型 : ',
    '水表状态': '水表状态 : ',
    '请选择水表状态': '请选择水表状态',
    '姓名': '姓名:',
    '请输入姓名': '请输入姓名',
    '联系电话': '联系电话:',
    '请输入电话': '请输入电话',
    '证件号码': '证件号码:',
    '请输入证件号码': '请输入证件号码',
    '小区': '小区:',
    '请选择小区': '请选择小区',
    '楼栋': '楼栋:',
    '请选择楼栋': '请选择楼栋',
    '单元': '单元:',
    '请选择单元': '请选择单元',
    '房间': '房间:',
    '请选择房间': '请选择房间',
    '注：如果不选择位置则保存之前的位置': '注：如果不选择位置则保存之前的位置',
    '保存': '保 存',
    '信息编辑': '信息编辑',
    '小区名称: ': '小区名称: ',
    '楼栋名称': '楼栋名称 : ',
    '单元名称': '单元名称 : ',
    '房间名称': '房间名称 : ',
    '成功': '成功',
    '修改成功': '修改成功',
    '添加小区成功': '添加小区成功',
    '添加楼栋成功': '添加楼栋成功',
    '添加单元成功': '添加单元成功',
    '添加楼房间成功': '添加楼房间成功',
  },
  // 水表档案详情页
  'fileDetails': {
    'projectHome': '项目首页',
    'basicData': '基础资料',
    'waterMeterFile': '水表档案',
    'fileDetails': '档案详情',
    'back': '返回',
    'meterId': '水表编号',
    'detailInfo': '详情信息',
    'waterType': '用水类型',
    'totalFlow': '累计流量',
    'balance': '余额',
    'onlineStatus': '在线状态',
    'valveStatus': '阀门状态',
    'meterType': '表具类型',
    'meterStatus': '水表状态',
    'netAccumulation': '净累计流量',
    'reverseAccumulation': '反向累计流量',
    'atAccumulation': '瞬时流量',
    'batteryVoltage': '电池电压',
    'signalStrength': '信号强度',
    'powerDown': '掉电状态',
    'powerLow': '低压状态',
    'magneticAttack': '磁攻击',
    'note': '注：水表状态启用指水表正常使用，开始扣费。停用指水表正常使用，停止扣费。',
    'delete': '删 除',
    'save': '保 存',
    'billFlow': '账单流水',
    'meterReading': '抄表记录',
    'switchValve': '开关阀记录',
    '设备日用量': '设备日用量',
    'deleteConfirm': '当前水表余额为 {balance} 是否删除水表档案？(请自行决定是否在删除水表档案前平账)',
    'deleteSuccess': '删除成功',
    'saveSuccess': '更改成功',
    '项目首页': '项目首页',
    '基础资料': '基础资料',
    '水表档案': '水表档案',
    '档案详情': '档案详情',
    '返回': '返回',
    '水表编号': '水表编号',
    '详情信息': '详情信息',
    '用水类型': '用水类型',
    '累计流量': '累计流量',
    '余额': '余额',
    '在线状态': '在线状态',
    '阀门状态': '阀门状态',
    '表具类型': '表具类型',
    '水表状态': '水表状态',
    '净累计流量': '净累计流量',
    '反向累计流量': '反向累计流量',
    '瞬时流量': '瞬时流量',
    '电池电压': '电池电压',
    '信号强度': '信号强度',
    '掉电状态': '掉电状态',
    '低压状态': '低压状态',
    '磁攻击': '磁攻击',
    '注：水表状态启用指水表正常使用，开始扣费。停用指水表正常使用，停止扣费。': '注：水表状态启用指水表正常使用，开始扣费。停用指水表正常使用，停止扣费。',
    '删除': '删 除',
    '保存': '保 存',
    '账单流水': '账单流水',
    '抄表记录': '抄表记录',
    '开关阀记录': '开关阀记录',
    '删除成功': '删除成功',
    '更改成功': '更改成功',
  },
  // 开关阀记录
  'switch': {
    'serialNumber': '序号',
    'meterId': '表号',
    'commandType': '操作内容',
    'status': '操作结果',
    'createTime': '创建时间',
    'sendTime': '发送时间',
    'completeTime': '完成时间',
    'responseResult': '响应结果',
    'loading': '拼命加载中',
    '拼命加载中': '拼命加载中',
    '水表编号': '水表编号',
    '操作内容': '操作内容',
    '操作结果': '操作结果',
    '创建时间': '创建时间',
    '发送时间': '发送时间',
    '完成时间': '完成时间',
    '响应结果': '响应结果',
  },
  // 账单流水
  'records': {
    'paymentId': '缴费编号',
    'meterId': '水表编号',
    'username': '用户姓名',
    'time': '时间',
    'amount': '本次金额',
    'address': '用户地址',
    'flow_use': '结算水量',
    'current_sum_flow': '表码数',
    'aft_money': '余额',
    'type': '账单类型',
    'status': '状态',
    'note': '备注',
    '水表编号': '水表编号',
    '缴费编号': '缴费编号',
    '用户姓名': '用户姓名',
    '时间': '时间',
    '本次金额': '本次金额',
    '用户地址': '用户地址',
    '结算水量': '结算水量',
    '表码数': '表码数',
    '余额': '余额',
    '账单类型': '账单类型',
    '状态': '状态',
    '备注': '备注',
  },
  // 抄表记录
  'meterRecord': {
    'index': '序号',
    'meterId': '表号',
    'sumFlow': '累计总用量',
    'unit': '单位',
    'plotReceiveTime': '抄表时间',
    'netAccumulation': '净累计流量',
    'reverseAccumulation': '反向累计流量',
    'atAccumulation': '瞬时流量',
    'batteryVoltage': '电池电压',
    'signalIntensity': '信号强度',
    'powerDown': '掉电状态',
    'powerLow': '低压状态',
    'magneticAttack': '磁攻击',
    'valveStatus': '阀门状态',
    'loading': '拼命加载中',
    '拼命加载中': '拼命加载中',
    '水表编号': '水表编号',
    '累计总用量': '累计总用量',
    '单位': '单位',
    '抄表时间': '抄表时间',
    '净累计流量': '净累计流量',
    '反向累计流量': '反向累计流量',
    '瞬时流量': '瞬时流量',
    '电池电压': '电池电压',
    '信号强度': '信号强度',
    '掉电状态': '掉电状态',
    '低压状态': '低压状态',
    '磁攻击': '磁攻击',
    '阀门状态': '阀门状态',
  },
  // 阀控策略页面
  'strategy': {
    'viewWhitelist': '查看阀控策略白名单',
    'name': '名称',
    'autoCloseValveForArrears': '欠费自动关阀',
    'alarmCloseValveStandard': '报警关阀标准',
    'oweCloseValveStandard': '欠费自动关阀标准',
    'operation': '操作',
    'modify': '修改',
    'accountEdit': '账号编辑',
    'selectOweOrNot': '请选择是否欠费',
    'alarmCloseValveRemainingAmount': '报警关阀剩余量',
    'oweCloseValveRemainingAmount': '欠费自动关阀剩余量',
    'currency': '元',
    'save': '保 存',
    'valveControlWhitelist': '阀控策略白名单',
    'enterMeterNumber': '请输入表号',
    'search': '查询',
    'refresh': '刷新',
    'meterNumber': '表号',
    'remove': '移除',
    '查看阀控策略白名单': '查看阀控策略白名单',
    '名称': '名称',
    '欠费自动关阀': '欠费自动关阀',
    '报警关阀标准': '报警关阀标准',
    '欠费自动关阀标准': '欠费自动关阀标准',
    '操作': '操作',
    '修改': '修改',
    '账号编辑': '账号编辑',
    '请选择是否欠费': '请选择是否欠费',
    '报警关阀剩余量': '报警关阀剩余量',
    '元': '元',
    '欠费自动关阀剩余量': '欠费自动关阀剩余量',
    '保 存': '保 存',
    '阀控策略白名单': '阀控策略白名单',
    '请输入水表编号': '请输入水表编号',
    '查询': '查询',
    '刷新': '刷新',
    '水表编号': '水表编号',
    '移除': '移除',
  },
  // 账户管理
  'userGement': {
    'projectHome': '项目首页',
    'systemManagement': '系统管理',
    'accountManagement': '账户管理',
    'addInfo': '添加信息',
    'userSettings': '用户设置',
    'username': '用户名',
    'password': '密码',
    'save': '保 存',
    'id': 'id',
    'projectName': '所属项目',
    'createDate': '创建日期',
    'isAdmin': '是否为管理员',
    'operation': '操作',
    '修改': '修 改',
    '删除': '删 除',
    'userModify': '用户修改',
    'deleteConfirm': '此操作将永久删除该用户, 是否继续?',
    'tip': '提示',
    'confirm': '确定',
    'cancel': '取消',
    'deleteSuccess': '删除成功',
    'deleteCancel': '已取消删除',
    'modifySuccessRedirect': '修改成功,跳转到登录页面！！！',
    'modifySuccess': '修改成功！！！',
    'addSuccess': '添加成功',
    'yes': '是',
    'no': '否',
    '项目首页': '项目首页',
    '系统管理': '系统管理',
    '账户管理': '账户管理',
    '添加信息': '添加信息',
    '用户设置': '用户设置',
    '用户名': '用户名',
    '密码': '密码',
    '保 存': '保 存',
    '所属项目': '所属项目',
    '创建日期': '创建日期',
    '是否为管理员': '是否为管理员',
    '是': '是',
    '否': '否',
    '操作': '操作',
    '用户修改': '用户修改',
    '此操作将永久删除该用户, 是否继续?': '此操作将永久删除该用户, 是否继续?',
    '提示': '提示',
    '确定': '确定',
    '取消': '取消',
    '删除成功': '删除成功',
    '已取消删除': '已取消删除',
    '修改成功,跳转到登录页面！！！': '修改成功,跳转到登录页面！！！',
    '修改成功！！！': '修改成功！！！',
    '添加成功': '添加成功',
  },
  // 全局配置
  'globalConfig': {
    'projectHome': '项目首页',
    'systemManagement': '系统管理',
    'globalConfiguration': '全局配置',
    'name': '名称',
    'address': '地址',
    'merchantId': '商户号',
    'wechatAppId': '公众号id',
    'balanceTipStandard': '余额不足标准',
    'operation': '操作',
    'modify': '修改',
    'uploadLogo': '上传logo',
    'accountEdit': '账号编辑',
    'projectName': '项目名称',
    'projectAddress': '项目地址',
    'balanceInsufficientAmount': '余额不足剩余量',
    'currency': '元',
    'save': '保 存',
    'modifySuccess': '修改成功',
    'uploadImage': '上传图片',
    'confirm': '确定',
    'uploadNote': '注：只能上传图片 且不得大于10MB',
    'pleaseSelectImage': '请选择图片在进行上传',
    '项目首页': '项目首页',
    '系统管理': '系统管理',
    '全局配置': '全局配置',
    '名称': '名称',
    '地址': '地址',
    '商户号': '商户号',
    '公众号id': '公众号id',
    '余额不足标准': '余额不足标准',
    '操作': '操作',
    '修改': '修改',
    '上传logo': '上传logo',
    '账号编辑': '账号编辑',
    '项目名称': '项目名称',
    '项目地址': '项目地址',
    '余额不足剩余量': '余额不足剩余量',
    '元': '元',
    '保 存': '保 存',
    '确定': '确定',
    '注：只能上传图片 且不得大于10MB': '注：只能上传图片 且不得大于10MB',
    '请选择图片在进行上传': '请选择图片在进行上传',
    '修改成功': '修改成功',
  },
  // 预警推送
  'alertPush': {
    'projectHome': '项目首页',
    'systemManagement': '系统管理',
    'alertPush': '预警推送',
    'bindWechat': '绑定接收者微信',
    'refresh': '刷 新',
    'id': 'id',
    'wechatNickname': '微信用户昵称',
    'wechatOpenid': '微信用户openid',
    'projectName': '项目名称',
    'bindTime': '绑定时间',
    'operation': '操作',
    'delete': '删 除',
    'bindTitle': '绑定接收者微信',
    'scanQRCode': '请使用微信扫码，显示绑定成功后关闭此窗口并点击刷新按钮。',
    'scanNote': '注意：使用此功能前必须先关注此项目对应的微信公众号，否则无法接收预警信息',
    'close': '关 闭',
    'deleteConfirm': '此操作将永久删除该预警推送者, 是否继续?',
    'tip': '提示',
    'confirm': '确定',
    'cancel': '取消',
    'deleteSuccess': '删除成功',
    'deleteCancel': '已取消删除',
    '项目首页': '项目首页',
    '系统管理': '系统管理',
    '预警推送': '预警推送',
    '绑定接收者微信': '绑定接收者微信',
    '刷 新': '刷 新',
    '请使用微信扫码，显示绑定成功后关闭此窗口并点击刷新按钮。': '请使用微信扫码，显示绑定成功后关闭此窗口并点击刷新按钮。',
    '注意：使用此功能前必须先关注此项目对应的微信公众号，否则无法接收预警信息': '注意：使用此功能前必须先关注此项目对应的微信公众号，否则无法接收预警信息',
    '关 闭': '关 闭',
    '微信用户昵称': '微信用户昵称',
    '微信用户openid': '微信用户openid',
    '项目名称': '项目名称',
    '绑定时间': '绑定时间',
    '操作': '操作',
    '删 除': '删 除',
    '此操作将永久删除该预警推送者, 是否继续?': '此操作将永久删除该预警推送者, 是否继续?',
    '提示': '提示',
    '确定': '确定',
    '取消': '取消',
    '删除成功': '删除成功',
    '已取消删除': '已取消删除',
  },
  'message': {
    'success': '成功',
    'exportSuccess': '导出成功',
    '成功': '成功',
    '导出成功': '导出成功',
  },
  // 通用
  'common': {
    'rangeSeparator': '至',
    'userLoginElsewhere': '用户在别处登录',
    '用户在别处登录': '用户在别处登录',
    '至': '至',
  },
  // 图表相关
  'chart': {
    'dayData': '号的数据是：',
    'waterUsage': '用水',
    '号的数据是：': '号的数据是：',
    '用水': '用水',
  },
  // 添加月度用水图表的中文翻译
  'homeMonth': {
    'month': '月',
    'waterUsage': '用水',
    'monthlyData': '月的数据是',
    '月的数据是': '月的数据是',
    '用水': '用水',
  },
  // 财务报表--充值记录和账单流水的查询
  'details': {
    'search': '请输入关键字',
    'datePicker': {
      'rangeSeparator': '至',
      'startPlaceholder': '开始日期',
      'endPlaceholder': '结束日期'
    },
    'community': '小区:',
    'selectCommunity': '请选择小区',
    'building': '楼栋:',
    'selectBuilding': '请选择楼栋',
    'unit': '单元:',
    'selectUnit': '请选择单元',
    'room': '房间:',
    'selectRoom': '请选择房间',
    'search_button': '查 询',
    'reset': '重 置',
    '请输入关键字': '请输入关键字',
    '小区': '小区:',
    '请选择小区': '请选择小区',
    '楼栋': '楼栋:',
    '请选择楼栋': '请选择楼栋',
    '单元': '单元:',
    '请选择单元': '请选择单元',
    '房间': '房间:',
    '请选择房间': '请选择房间',
    '查询': '查 询',
    '重置': '重 置',
  }
}
       
